import React, { lazy } from 'react'
import { Route } from 'react-router-dom'

const WorkspaceSettings = lazy(() => import('../modules/WorkspaceSettings'))
const AcceptInvitation = lazy(() => import('../modules/WorkspaceSettings/components/AcceptInvitation/AcceptInvitation'))

export const workspaceRoutes = [
  <Route key='workspace-settings' path='/workspace/settings' element={<WorkspaceSettings />} />,
  <Route key='workspace-invite-verify' path='/workspace/invite/verify/:token' element={<AcceptInvitation />} />
]
